const env = process.env;
const runtimeConfig = typeof window !== 'undefined'
    ? (window.__UMIME_APP_CONFIG__ || window.__APP_CONFIG__ || {})
    : {};

const getConfigValue = (runtimeKey, envKey, fallback = '') => {
    const runtimeValue = runtimeConfig[runtimeKey] ?? runtimeConfig[envKey];

    if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
        return runtimeValue;
    }

    return env[envKey] || fallback;
};

const withTrailingSlash = (value) => {
    const normalized = String(value || '').trim();

    return normalized ? normalized.replace(/\/+$/, '') + '/' : '';
};

const withoutTrailingSlash = (value) => String(value || '').trim().replace(/\/+$/, '');

export const appTitle     = getConfigValue('title', 'REACT_APP_TITLE', 'lexikaizen.com');
export const storageUrl   = withoutTrailingSlash(getConfigValue('storageUrl', 'REACT_APP_STORAGE_URL'));
export const apiUrl       = withTrailingSlash(getConfigValue('apiUrl', 'REACT_APP_API_URL'));
export const apiKey       = getConfigValue('apiKey', 'REACT_APP_API_KEY');
export const thumbHeight  = Number(getConfigValue('thumbHeight', 'REACT_APP_THUMB_HEIGHT', 300));
export const thumbQuality = Number(getConfigValue('thumbQuality', 'REACT_APP_THUMB_QUALITY', 80));
export const authApiUrl   = getConfigValue('authApiUrl', 'REACT_APP_AUTH_API_URL');
export const authLoginUrl = getConfigValue('authLoginUrl', 'REACT_APP_AUTH_LOGIN_URL');
export const evaluationApiUrl = getConfigValue('evaluationApiUrl', 'REACT_APP_EVALUATION_API_URL');
export const homepageUrl = withTrailingSlash(getConfigValue('homepageUrl', 'REACT_APP_HOMEPAGE_URL', 'https://www.lexikaizen.com/'));

export const getCalculatorUrl = (languageCode) => {
    const url = new URL(homepageUrl);
    if (availableLanguages.some((language) => language.code === languageCode)) {
        url.searchParams.set('subjects', languageCode);
    }
    url.hash = 'pricing';
    return url.toString();
};

export const availableLanguages = [
    { code: 'en', name: 'English' }, // tento jazyk je zakladni a nejde odebrat
    { code: 'es', name: 'EspaĂ±ol' },  // tento jazyk je zakladni a nejde odebrat
    { code: 'fr', name: 'FranĂ§ais' }
    // { code: 'de', name: 'Deutsch' }

];

export const availableThemes = [
    'default',
    'pink',
    'blue',
    'green',
    'red',
    // 'yellow'
];

export const initLang  = availableLanguages[0].code;
export const initTheme = availableThemes[0];
export const normalizeTheme = (theme) => availableThemes.includes(theme) ? theme : initTheme;


